module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "_idGenObjectStyleOverride-1"
  }, [_c('h1', {
    staticClass: "•-CH-TITLE-8-4-2015",
    attrs: {
      "id": "_idParaDest-4"
    }
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor003"
    }
  }), _vm._v("Editor’s Note")]), _vm._v(" "), _c('p', {
    staticClass: "•-CH-TITLE-DETAILS-8-4-2015 ParaOverride-4"
  }, [_vm._v("from Diane Mermigas")]), _vm._v(" "), _c('p', {
    staticClass: "•-BODY-NO-INDENT-8-4-2015-c"
  }, [_vm._v("My first wide-ranging interview with Bob was in late 1986. I was a national business reporter and he had just stepped out of the GE stable into the network television horserace. Quietly undeterred in his plans to revolutionize the industry, Bob’s entrepreneurial drive and innovative vision were as compelling then as they are today.")]), _vm._v(" "), _c('p', {
    staticClass: "•-BODY-8-4-2015"
  }, [_vm._v("In the years that followed, our regular discussions always morphed into a lively exchange of ideas. For more than 3 decades, we shared a passion and curiosity about the forces reshaping media. So, it was fitting that Bob asked me to help tell his story, which, in typical fashion, evolved from a simple personal journal into a leadership treatise. ")]), _vm._v(" "), _c('p', {
    staticClass: "•-BODY-8-4-2015"
  }, [_vm._v("At the same time, Bob and Suzanne’s nonprofit trailblazing at Autism Speaks became an unexpected second act for their skills and contacts guided by her heart, his head. As someone familiar with special needs children, I understood their family’s angst and struggle with autism. ")]), _vm._v(" "), _c('p', {
    staticClass: "•-BODY-8-4-2015"
  }, [_vm._v("The book’s vignettes are rooted in more than 100 interviews exploring many common issues, personalities, and companies.")]), _vm._v(" "), _c('p', {
    staticClass: "•-BODY-8-4-2015"
  }, [_vm._v("If "), _c('span', {
    staticClass: "CharOverride-8"
  }, [_vm._v("The Wright Stuff")]), _vm._v(" naturally embraces the multifaceted encounters and challenges permeating Bob’s professional and personal lives, it is because they are inseparable. Together they provide a powerful profile in mastering change. ")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-21f54a4d","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/ebook_-_test-3.vue
// module id = 66
// module chunks = 0